// Per-tenant client keys used to switch avatar/branding behavior.
// Keeping these in one place makes it easy to onboard a new client
// without touching ChatProvider's logic.

export const SHOJI_CLIENT_KEYS = [
  "stg-drinkers-client-key",
  "stg-syurui-client-key",
  "uEuxYtcROOmfY7WvO3l7JcXmksqyF9p8X6Hen9sNnFM=",
  "eeF9ylUGxMQ94kMi0qtktRCtHY3adi4klnp921Q4W8g=",
];

export const TAIGA_CLIENT_KEYS = ["y6VZ2PKT-zwOc-JLNWsoKEC44zrKiqjhmhV10e3skhg="];

export const AVATAR_ICONS = {
  SHOJI: "general",
  MAIRA: "maira",
  TAIGA: "taiga_ai",
};

export const isShojiClient = (clientKey) => SHOJI_CLIENT_KEYS.includes(clientKey);
export const isTaigaClient = (clientKey) => TAIGA_CLIENT_KEYS.includes(clientKey);
